import React, { FormEvent, useCallback, useEffect, useState } from 'react';
import './NewDossier.scss';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import { useHistory } from 'react-router-dom';
import Form from 'react-bootstrap/esm/Form';
import Col from 'react-bootstrap/esm/Col';
import Alert from 'react-bootstrap/esm/Alert';
import Button from 'react-bootstrap/esm/Button';
import Spinner from 'react-bootstrap/esm/Spinner';
import { Api } from '../../api';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { DossierV2 } from '../../models/DossierV2';
import { ERouterPath } from '../../features/router/ERouterPath';

const NewDossier = (): JSX.Element => {
  const [dossierName, setDossierName] = useState<string>('');
  const [dossierNameError, setDossierNameError] = useState<string|undefined>(undefined);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [createdDossier, setCreatedDossier] = useState<DossierV2|undefined>(undefined);
  const history = useHistory();

  const inputName = 'name';

  const validateDossierName = useCallback((): boolean => {
    if (dossierName.length < 1) {
      setDossierNameError('Vul een naam in');
      return false;
    } else if (dossierName.length > 128) {
      setDossierNameError(`Dossiernaam is te lang (${dossierName.length}/128 tekens)`);
      return false;
    }
    setDossierNameError(undefined);
    return true;
  }, [dossierName]);

  useEffect(() => {
    if (dossierNameError) {
      validateDossierName();
    }
  }, [dossierNameError, validateDossierName]);

  const handleDossierNameChange = (value: string): void => {
    setDossierName(value.trimStart());
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const isValid = validateDossierName();
    if (!isValid) {
      return; // Error is displayed by validateDossierName()
    }
    setSubmitting(true);
    Api.createDossier(dossierName.trim())
      .then(dossier => {
        setCreatedDossier(dossier);
      })
      .catch(() => {
        NotificationHelper.toastError('Aanmaken dossier mislukt door een onverwachte fout');
      })
      .finally(() => setSubmitting(false));
  };

  const renderForm = () => <>
    <h2>Nieuw dossier aanmaken</h2>
    <Form className="add-client-input__form" onSubmit={handleSubmit}>
      <Form.Row>
        <Form.Group as={Col} className="form__item add-client-input__initials">
          <Form.Control
            name={inputName}
            placeholder="Naam van dossier"
            type="text"
            autoComplete="off"
            onChange={e => handleDossierNameChange(e.target.value)}
            value={dossierName}
            isInvalid={!!dossierNameError}
          />
          {dossierNameError && <Alert className="add-client__danger" variant="danger">{dossierNameError}</Alert>}
        </Form.Group>

        <Form.Group as={Col} className="form__item add-client-input__name">
          <Button type="submit" disabled={submitting}>
            {submitting && <Spinner animation="border" variant="light" />}
            Aanmaken
          </Button>
        </Form.Group>
      </Form.Row>
    </Form>
  </>;

  const renderSubmittedMessage = () => <>
    <div>Je hebt een Dossier aangemaakt met de naam: {dossierName}, wil je daar een persoon aan toevoegen?</div>
    <div className="button-group">
      { createdDossier && <Button onClick={() => history.push(`${ERouterPath.newPerson}/?add-to-dossier=${createdDossier.id}`)}>Ja</Button> }
      <Button onClick={() => history.push(ERouterPath.allDossiers)}>Nee</Button>
    </div>
  </>;

  return (
    <DashboardLayout className="new-dossier" noTabs={true} backButton={true}>
      { createdDossier ? renderSubmittedMessage() : renderForm() }
    </DashboardLayout>
  );
};

export default NewDossier;
